<opac-toast
  @grow
  @visibility
  *ngFor="let toast of toasts(); trackBy: toastsTrackByFn"
  [id]="toast.id"
  [variant]="toast.type"
>
  {{ toast.message }}
</opac-toast>
